export const init = () => {
  // TRACKER 'CUSTOMER-ADDRESS-BOOK'
  const tracker = new AnalyticsTracker(AnalyticsConstants.trackers.customer.addressBook);

  // - ClickMenu ==> MOVED TO 'menu-tracker.js'
  //var clickMenu = new AnalyticsClickEvent('clickMenu', tracker.defaultEvent());
  //clickMenu.domElement = '#preferences > ul > li:first-child';
  //clickMenu.options.label = 'ClickMenu';
  //tracker.addEvent(clickMenu);


  // - NewAdressBookClick
  const newAdressBookClick = new AnalyticsClickEvent('newAdressBookClick', tracker.defaultEvent());
  newAdressBookClick.domElement = '#address-book-list > div.options-nav > a';
  newAdressBookClick.options.label = 'NewAdressBookClick';
  newAdressBookClick.postAction(() => {
    sessionStorage.setItem(AnalyticsConstants.ref.addrBookEdit, false);
  });
  tracker.addEvent(newAdressBookClick);

  // - ModifiyAdressBookClick
  const modifiyAdressBookClick = new AnalyticsClickEvent('modifiyAdressBookClick', tracker.defaultEvent());
  modifiyAdressBookClick.domElement = '#address-book-list-table div.address-container a.modify-item';
  modifiyAdressBookClick.options.label = 'ModifiyAdressBookClick';
  modifiyAdressBookClick.postAction(() => {
    sessionStorage.setItem(AnalyticsConstants.ref.addrBookEdit, true);
  });
  tracker.addEvent(modifiyAdressBookClick);


  // - NEW/MODIFY AdressBookValidation
  const adressBookValidation = new AnalyticsQueueEvent('adressBookValidation', tracker.defaultEvent());
  adressBookValidation.trigger = 'click';
  adressBookValidation.domElement = '#add-shipping-btn';
  adressBookValidation.getLabel = function() {
    if (sessionStorage.getItem(AnalyticsConstants.ref.addrBookEdit) &&
				JSON.parse(sessionStorage.getItem(AnalyticsConstants.ref.addrBookEdit)) === true)
      return 'ModifiyAdressBookValidation';
    return 'NewAdressBookValidation';
  };
  adressBookValidation.postAction(() => { sessionStorage.removeItem(AnalyticsConstants.ref.addrBookEdit); });
  tracker.addEvent(adressBookValidation);


  // - NEW/MODIFYAdressBookBack
  const modifiyAdressBookBack = new AnalyticsClickEvent('modifiyAdressBookBack', tracker.defaultEvent());
  modifiyAdressBookBack.domElement = '#back-address-book-btn';
  modifiyAdressBookBack.getLabel = function() {
    if (sessionStorage.getItem(AnalyticsConstants.ref.addrBookEdit) &&
				JSON.parse(sessionStorage.getItem(AnalyticsConstants.ref.addrBookEdit)) === true)
      return 'ModifiyAdressBookBack';
    return 'NewAdressBookBack';
  };
  modifiyAdressBookBack.postAction(() => { sessionStorage.removeItem(AnalyticsConstants.ref.addrBookEdit); });
  tracker.addEvent(modifiyAdressBookBack);

  // - AdressBookDeletionClick
  const adressBookDeletionClick = new AnalyticsClickEvent('adressBookDeletionClick', tracker.defaultEvent());
  adressBookDeletionClick.domElement = '#address-book-list-table div.table-action a.delete-item';
  adressBookDeletionClick.options.label = 'AdressBookDeletionClick';
  tracker.addEvent(adressBookDeletionClick);

  // - AdressBookDeletionValidationYes
  const adressBookDeletionValidationYes = new AnalyticsClickEvent('adressBookDeletionValidationYes', tracker.defaultEvent());
  adressBookDeletionValidationYes.domContainer = '.modal-delete-address';
  adressBookDeletionValidationYes.domElement = '.confirm-deletion';
  adressBookDeletionValidationYes.options.label = 'AdressBookDeletionValidationYes';
  tracker.addEvent(adressBookDeletionValidationYes);

  // - AdressBookDeletionValidationNo
  const adressBookDeletionValidationNo = new AnalyticsClickEvent('adressBookDeletionValidationNo', tracker.defaultEvent());
  adressBookDeletionValidationNo.domContainer = '.modal-delete-address';
  adressBookDeletionValidationNo.domElement = '.cancel-deletion';
  adressBookDeletionValidationNo.options.label = 'AdressBookDeletionValidationNo';
  tracker.addEvent(adressBookDeletionValidationNo);

  // - FavoriteAdressBookModification
  const favoriteAdressBookModification = new AnalyticsTriggerEvent('favoriteAdressBookModification', tracker.defaultEvent());
  favoriteAdressBookModification.trigger = 'change';
  favoriteAdressBookModification.domElement = '#address-book-list-table div.radio input[name="favoriteRadioButton"]';
  favoriteAdressBookModification.options.label = 'FavoriteAdressBookModification';
  tracker.addEvent(favoriteAdressBookModification);

  // - HomeAdressCheckBox
  const homeAdressCheckBox = new AnalyticsTriggerEvent('homeAdressCheckBox', tracker.defaultEvent());
  homeAdressCheckBox.trigger = 'change';
  homeAdressCheckBox.domContainer = '#add-address-container label[for="home-delivery"]';
  homeAdressCheckBox.domElement = 'input#home-delivery';
  homeAdressCheckBox.options.label = 'HomeAdressCheckBox';
  tracker.addEvent(homeAdressCheckBox);

  // - FavoriteAdressBookSelection
  const favoriteAdressBookSelection = new AnalyticsTriggerEvent('favoriteAdressBookSelection', tracker.defaultEvent());
  favoriteAdressBookSelection.trigger = 'change';
  favoriteAdressBookSelection.domContainer = '#add-address-container label[for="favorite-address"]';
  favoriteAdressBookSelection.domElement = 'input#favorite-address';
  favoriteAdressBookSelection.options.label = 'FavoriteAdressBookSelection';
  tracker.addEvent(favoriteAdressBookSelection);


  /*
	 * BILLING VIEW
	 */


  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);

};



// WEBPACK FOOTER //
// ./src/analytics/trackers/customer/address-book-tracker.js